(function () {
'use strict';

angular
    .module('riskEventEditRoutes', [
        'riskEventEditModule'
    ])
    .config(router);

router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

             // Risk Event not exists
             .state('riskEventNotExists', {
                 url: '/RiskEvent/{RiskEventID:int}/NotExists',
                 templateUrl: require('./riskEventNotExists.tpl.html')
             })

             // Add Risk Event
             .state('riskEventAdd', {
                 url: '/RiskEvent/Add',
                 resolve: {
                     riskEvent: [function () {
                         return { ItemCssIcon: 'fa fa-newspaper-o' };
                     }]
                 },
                 templateUrl: require('./riskEventEdit.tpl.html'),
                 controller: 'RiskEventEditController',
             })

             // Edit Risk Event
             .state('riskEventEdit', {
                 url: '/RiskEvent/{RiskEventID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     riskEvent: ['$stateParams', 'grcRiskEventService', function ($stateParams, service) {
                         return service.getRiskEvent($stateParams.RiskEventID);
                     }]
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'RiskEventEditController'
                     },
                     'mainContent@riskEventEdit': {
                         templateUrl: require('./riskEventEdit.tpl.html')
                     }
                 }
             })

             // Related Risks
             .state('riskEventEdit.RelatedRisks', {
                 url: '/Risk',
                 resolve: {
                     relatedRisks: ['$stateParams', 'grcRiskEventService', function ($stateParams, service) {
                         return service.getRelatedRisks($stateParams.RiskEventID);
                     }]
                 },
                 views: {
                     'mainContent@riskEventEdit': {
                         templateUrl: require('./relatedRisks.tpl.html'),
                         controller: 'RiskEventRelatedRisksController'
                     }
                 }
             })

        historyCtxtServiceProvider.setCtxtState('riskEventEdit',
            '/app/Main/grcEdit/riskEvent/GOVHistoryCtxtDirective-riskEventRelatedRisks.tpl.html'
        );
    }
})();